import React from "react";
import { AbsoluteFill, useCurrentFrame, useVideoConfig } from "remotion";
import {
  chainAt,
  clamp,
  layers,
  progressAt,
  tracePath,
  turnAt,
} from "./geometry";

export const BloomingMandalaSpirograph: React.FC = () => {
  const frame = useCurrentFrame();
  const { fps } = useVideoConfig();
  const seconds = frame / fps;
  return (
    <AbsoluteFill>
      <MandalaArtwork seconds={seconds} />
    </AbsoluteFill>
  );
};

export const MandalaArtwork: React.FC<{ seconds: number }> = ({ seconds }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1080"
      height="1920"
      viewBox="0 0 1080 1920"
      style={{ width: "100%", height: "100%" }}
    >
      <defs>
        <radialGradient id="mandala-background">
          <stop offset="0" stopColor="#1b1940" />
          <stop offset="0.65" stopColor="#10132b" />
          <stop offset="1" stopColor="#070b1b" />
        </radialGradient>
        <filter id="mandala-glow" x="-20%" y="-20%" width="140%" height="140%">
          <feGaussianBlur stdDeviation="3" />
        </filter>
      </defs>
      <rect width="1080" height="1920" fill="url(#mandala-background)" />
      <g transform="translate(510 905)">
        {layers.map((layer, index) => {
          if (seconds < layer.start) return null;
          const progress = progressAt(layer, seconds);
          const path = tracePath(index, progress);
          return (
            <g
              key={index}
              fill="none"
              stroke={layer.color}
              strokeLinejoin="round"
              strokeLinecap="round"
            >
              <path
                d={path}
                strokeWidth="5"
                opacity="0.24"
                filter="url(#mandala-glow)"
              />
              <path
                d={path}
                strokeWidth={index === 2 ? 1.9 : 2.2}
                opacity="0.92"
              />
            </g>
          );
        })}
        {layers.map((layer, index) => {
          if (seconds < layer.start) return null;
          const chain = chainAt(layer, turnAt(layer, seconds));
          const tip = chain[chain.length - 1];
          const appear =
            index === 0 ? 1 : clamp((seconds - layer.start) / 0.35);
          // Keep all active circles visible, including during the final hold.
          return (
            <g key={index} opacity={appear}>
              <g
                fill="none"
                stroke="#b9c7ef"
                strokeWidth="1.3"
                opacity={index === 0 ? 0.36 : 0.19}
              >
                {layer.radii.map((radius, i) => (
                  <circle key={i} cx={chain[i].x} cy={chain[i].y} r={radius} />
                ))}
                <polyline
                  points={chain.map((p) => `${p.x},${p.y}`).join(" ")}
                />
              </g>
              {chain.slice(0, -1).map((p, i) => (
                <circle
                  key={i}
                  cx={p.x}
                  cy={p.y}
                  r="2.5"
                  fill="#c8d4f5"
                  opacity="0.5"
                />
              ))}
              <circle
                cx={tip.x}
                cy={tip.y}
                r="9"
                fill={layer.color}
                opacity="0.5"
                filter="url(#mandala-glow)"
              />
              <circle cx={tip.x} cy={tip.y} r="3.5" fill="#f6ffff" />
            </g>
          );
        })}
      </g>
    </svg>
  );
};

